import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Box,
  Button,
} from "@mui/material";
import { useLocation, Link } from "react-router-dom";

const CreateSettlementDetails = () => {
  const location = useLocation();
  const { row } = location.state || {};
console.log("row", row)
  if (!row) {
    return <Typography>No order details found.</Typography>;
  }

  const billing = row?.order?.billing;
  const address = billing?.address;
  const fulfillment = row?.order?.fulfillments?.[0];
  const context = row?.context;

  return (
    <Card sx={{ maxWidth: "95%", margin: "auto", mt: 4, p: 2 }}>
      <CardContent>
        <Typography variant="h4" gutterBottom>
          Create Order Details
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {/* Basic Info */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography><strong>Order ID:</strong> {row.ondcOrderId}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Transaction ID:</strong> {row.transactionId}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Customer ID:</strong> {row.customerId}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Status:</strong> {row.order?.state}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Created At:</strong> {new Date(row.createdAt).toLocaleString()}</Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Billing Info */}
        <Typography variant="h6">Billing</Typography>
        <Box sx={{ pl: 2, my: 1, borderLeft: "2px solid #ccc" }}>
          <Typography><strong>Name:</strong> {billing?.name}</Typography>
          <Typography><strong>Phone:</strong> {billing?.phone}</Typography>
          <Typography><strong>Email:</strong> {billing?.email}</Typography>
          <Typography><strong>Address:</strong> {`${address?.building}, ${address?.locality}, ${address?.city}, ${address?.state}, ${address?.country}, ${address?.area_code}`}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Fulfillment Info */}
        <Typography variant="h6">Fulfillment</Typography>
        <Box sx={{ pl: 2, my: 1, borderLeft: "2px solid #4caf50" }}>
          <Typography><strong>Type:</strong> {fulfillment?.type}</Typography>
          <Typography><strong>Provider:</strong> {fulfillment?.["@ondc/org/provider_name"]}</Typography>
          <Typography><strong>Status:</strong> {fulfillment?.state?.descriptor?.code}</Typography>
          <Typography><strong>Start Location:</strong> {fulfillment?.start?.location?.descriptor?.name}</Typography>
          <Typography><strong>End GPS:</strong> {fulfillment?.end?.location?.gps}</Typography>
          <Typography><strong>Receiver:</strong> {fulfillment?.end?.person?.name}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Quote */}
        <Typography variant="h6">Quote</Typography>
        <Box sx={{ pl: 2, my: 1, borderLeft: "2px solid #2196f3" }}>
          <Typography><strong>Price:</strong> ₹{row?.order?.quote?.price?.value} {row?.order?.quote?.price?.currency}</Typography>
          <Typography><strong>TTL:</strong> {row?.order?.quote?.ttl}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Context */}
        <Typography variant="h6">Context</Typography>
        <Box sx={{ pl: 2, my: 1, borderLeft: "2px solid #9c27b0" }}>
          <Typography><strong>Domain:</strong> {context?.domain}</Typography>
          <Typography><strong>Action:</strong> {context?.action}</Typography>
          <Typography><strong>BAP:</strong> {context?.bap_id}</Typography>
          <Typography><strong>BPP:</strong> {context?.bpp_id}</Typography>
          <Typography><strong>Timestamp:</strong> {new Date(context?.timestamp).toLocaleString()}</Typography>
        </Box>

        {/* Back Button */}
        <Box sx={{ mt: 4 }}>
          <Button component={Link} to="/app/management/create-settlement" variant="outlined">
            Back
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CreateSettlementDetails;
